import { BetterStackLoggerService } from './BetterStackLogger';
import type { ILogger } from '@types';

export const logger: ILogger & BetterStackLoggerService = new BetterStackLoggerService();
